<template>
  <div style="height: calc(100% - 20px);padding-top: 16px">
    <el-container class="fullheight" style="border: 1px solid #eee">
      <eco-menu-manager ref="ecoMenuManager" @node-click="handleNodeClick" :showEdit="false" node-key="id" @menu-action="menuAction" hideMenu i18nAPi />
      <!--  内容 -->
      <el-container style="padding: 16px">
        <eco-table
          @load="loadData"
          :data="data"
          :pageResult="pageResult"
          quick-search-props="portal_sys_menu.NAME_,portal_i18n_message.KEY_,portal_i18n_message.VALUE_"
          :show-export="false"
          ref="ecoTable"
        >
          <template>
            <eco-table-column type="index" width="50" align="center" label="序号" />
            <eco-table-column prop="portal_sys_menu.NAME_" label="菜单名称" />
            <eco-table-column prop="pageType" label="页面类型">
              <template v-slot="{ row, column, $index }">
                {{ transBValueList(fieldPageTypeList, row.pageType) }}
              </template>
            </eco-table-column>
            <eco-table-column prop="pageArea" label="页面区域">
              <template v-slot="{ row, column, $index }">
                {{ row.formName || row.listConfigName }}
              </template>
            </eco-table-column>
            <eco-table-column prop="fieldType" label="字段类型">
              <template v-slot="{ row, column, $index }">
                {{ transBValueList(fieldTypeList, row.fieldType) }}
              </template>
            </eco-table-column>
            <eco-table-column prop="portal_i18n_message.KEY_" label="字段KEY" />
            <eco-table-column prop="portal_i18n_message.VALUE_" label="系统字段名称" />
            <eco-table-column prop="customValue" label="用户字段名称" :hidden="tenantId === '-1'" />
            <eco-table-column label="操作" :hidden="tenantId === '-1'">
              <template v-slot="{ row, column, $index }">
                <el-link type="primary" @click="handleCommand({ row: row, command: 'edit' })" title="点击编辑">编辑</el-link>
              </template>
            </eco-table-column>
          </template>
        </eco-table>
      </el-container>

      <el-drawer
        class="sideDrawer"
        destroy-on-close
        :size="drawerSize"
        title="编辑"
        :visible="handleDialog"
        :before-close="handleClose"
        :close-on-click-modal="false"
        append-to-body
      >
        <el-form :model="referTypeRow" style="padding: 10px 20px">
          <el-form-item label="菜单名称" label-width="100px">
            {{ referTypeRow.menuName }}
          </el-form-item>
          <el-form-item label="页面类型" label-width="100px">
            {{ transBValueList(fieldPageTypeList, referTypeRow.pageType) }}
          </el-form-item>
          <el-form-item label="页面区域" label-width="100px">
            {{ referTypeRow.formName || referTypeRow.listConfigName }}
          </el-form-item>
          <el-form-item label="字段类型" label-width="100px">
            {{ transBValueList(fieldTypeList, referTypeRow.fieldType) }}
          </el-form-item>
          <el-form-item label="字段KEY" label-width="100px">
            {{ referTypeRow.key }}
          </el-form-item>
          <el-form-item label="系统字段名称" label-width="100px">
            {{ referTypeRow.value }}
          </el-form-item>
          <el-form-item label="用户字段名称" label-width="100px">
            <el-input v-model="referTypeRow.customValue" maxlength="200" style="width: 100%"></el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button size="small" @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleSave" size="small" :loading="loading">确 定</el-button>
        </div>
      </el-drawer>
    </el-container>
  </div>
</template>
<script>
import request from '@/request'
import utils from '@/utils'
import { mapState } from 'vuex'
const EcoMenuManager = () => import('@/components/system/FeMenuManager.vue')
export default {
  name: 'customField',
  components: {
    EcoMenuManager
  },
  data() {
    return {
      drawerSize: '28%',
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      fieldPageTypeList: [],
      fieldPageAreaList: [],
      fieldTypeList: [],
      tenantId: '',
      alias: '',
      handleDialog: false,
      loading: false,
      referTypeRow: {
        customValue: ''
      }
    }
  },
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict,
      allEnumerate: (state) => state.user.allEnumerate
    })
  },
  mounted() {
    if (sessionStorage.currentTenantId) {
      this.tenantId = sessionStorage.currentTenantId
    }
    this.fieldPageTypeList = utils.getAllEnumerateAttr({
      isShowList: true,
      typeKey: 'I18nMessagePageTypeEnums',
      allData: this.allEnumerate
    })
    this.fieldPageAreaList = utils.getAllEnumerateAttr({
      isShowList: true,
      typeKey: 'I18nMessagePageAreaEnums',
      allData: this.allEnumerate
    })
    this.fieldTypeList = utils.getAllEnumerateAttr({
      isShowList: true,
      typeKey: 'I18nMessageFieldTypeEnums',
      allData: this.allEnumerate
    })
  },
  methods: {
    transBValueList(bValue, val) {
      if (bValue) {
        let p = bValue.find((item) => item.value === val)
        return p ? p.label : val
      } else return val
    },
    handleCommand(params) {
      switch (params.command) {
        case 'edit':
          this.showDialog(params.row)
          break
        default:
          break
      }
    },
    showDialog(row) {
      this.referTypeRow = row
      this.handleDialog = true
    },
    loadData(param, cb) {
      if (!param.querys) param.querys = []
      if (this.alias) {
        let findIndex = param.querys.find((item) => item.property === 'portal_sys_menu.PATH_')
        if (findIndex) {
          findIndex.value = `.${this.alias}.`
        } else {
          param.querys.push({
            property: 'portal_sys_menu.PATH_',
            value: `.${this.alias}.`,
            group: 'advanced',
            relation: 'AND',
            operation: 'LIKE'
          })
        }
      } else {
        if (this.alias) {
          param.querys.push([
            {
              property: 'portal_sys_menu.PATH_',
              value: `.${this.alias}.`,
              group: 'advanced',
              relation: 'AND',
              operation: 'LIKE'
            }
          ])
        } else {
        }
      }
      request
        .post('${portal}/i18n/custom/i18nMessage/v1/customQuery', param)
        .then((response) => {
          response.data.rows.forEach((item) => {
            item.portal_sys_menu = {}
            item.portal_i18n_message = {}
            item.portal_sys_menu['NAME_'] = item.menuName
            item.portal_i18n_message['KEY_'] = item.key
            item.portal_i18n_message['VALUE_'] = item.value
          })
          this.data = response.data.rows
          this.pageResult = {
            page: response.data.page,
            pageSize: response.data.pageSize,
            total: response.data.total
          }
        })
        .finally(() => cb())
    },
    handleNodeClick(val) {
      this.alias = val.id.replace(this.tenantId, '')
      this.$refs.ecoTable.load()
    },
    menuAction(val) {
      console.log(val)
    },
    handleSave(cb) {
      this.loading = true
      let param = Object.assign({}, this.referTypeRow)
      request
        .post('${portal}/i18n/custom/i18nMessage/v1/editCustom', param)
        .then((response) => {
          if (response && response.data && response.data.state) {
            this.$message({
              type: 'success',
              message: response.data.message
            })
            this.$refs.ecoTable.load()
            this.handleClose()
            this.loading = false
          }
        })
        .finally(() => cb() && (this.loading = false))
    },
    handleClose() {
      this.loading = false
      this.handleDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .error-small {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 0;
  margin-top: 0;
  position: absolute;
  top: 80%;
  left: 0;
}
>>> .el-table td,
th {
  padding: 13px 0;
}

.form-empty {
  position: absolute;
  text-align: center;
  width: 300px;
  font-size: 20px;
  top: 200px;
  left: 50%;
  margin-left: -150px;
  color: #ccc;
}
</style>
